import styled from "@emotion/styled";
import { RequiredThemeKeys } from "../../../util/theme";
import { formInputTheme } from "../../textinput/styled/formInputTheme";
import { TypeRampV2 } from "../../typography";

interface SelectButtonTextProps {
    themeMode: RequiredThemeKeys;
}

export const SelectButtonText = styled(TypeRampV2)<SelectButtonTextProps>`
    min-width: 0;
    text-align: start;
    color: ${({ themeMode }) => formInputTheme.textColor.rest(themeMode)};
`;
